import { Fragment, useContext, useEffect, useRef, useState } from "react";

import "./navigation.scss";

import { ThemeContext } from "../../App";

import Link from "../link/link";

function Navigation(props) {
  let indicator = useRef(null);

  const { overlayOpened, visibleSection } = useContext(ThemeContext);

  let [activeMenu, setActiveMenu] = useState(false);

  function removeActiveMenuItem() {
    const menuItems = document.querySelectorAll(".navigation__menu-item");
    menuItems.forEach((element) => {
      element.classList.remove("navigation__menu-item--active");
    });
  }

  function activateMenuItem(target) {
    removeActiveMenuItem();

    target.classList.add("navigation__menu-item--active");

    setIndicator(target);
  }

  function setIndicator(activeMenuItem) {
    indicator = document.querySelector(".navigation__menu-item-indicator");

    // check how wide the document is and if its width is below 768 then console log mobile
    if (document.body.clientWidth < 768) {
      indicator.style.height = `${activeMenuItem.offsetHeight}px`;
      indicator.style.top = `${activeMenuItem.offsetTop}px`;

      // reset to default
      indicator.style.width = `4px`;
      indicator.style.left = `0px`;
    } else {
      indicator.style.width = `${activeMenuItem.offsetWidth}px`;
      indicator.style.left = `${activeMenuItem.offsetLeft}px`;

      // reset to default
      indicator.style.height = `4px`;
      indicator.style.top = `0px`;
    }
  }

  function goToSection(e, id) {
    e.preventDefault();

    const onMobile = document.body.clientWidth < 768 || false;
    const targetElement = document.getElementById(id);
    if (targetElement) {
      window.scrollTo({
        top: onMobile
          ? targetElement.offsetTop - 20
          : targetElement.offsetTop - 100,
        behavior: "smooth",
      });
    }

    activateMenuItem(e.target);
    setActiveMenu(false);
  }

  useEffect(() => {
    const activeMenuItem = document.querySelector(
      ".navigation__menu-item--active"
    );

    setIndicator(activeMenuItem);

    const handleResize = () => setIndicator(activeMenuItem);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const menuItems = document.querySelectorAll(".navigation__menu-item");

    Array.from(menuItems).find((element) => {
      if (element.id === `navi-${visibleSection}`) {
        activateMenuItem(element);
      }

      return null;
    });
  }, [visibleSection]);

  return (
    <Fragment>
      <header
        className={`navigation l-container${
          activeMenu ? " navigation--active" : ""
        }`}
      >
        <div className="navigation__menu">
          <Link
            href="/"
            text="Home"
            id="navi-home"
            className="navigation__menu-item navigation__menu-item--active"
            internLink
            ariaLabel="Link zur home sektion"
          />

          {props.items &&
            props.items.map((element, index) => (
              <Link
                text={element.name}
                href={`#${element.id}`}
                id={`navi-${element.id}`}
                className="navigation__menu-item"
                onClick={(e) => goToSection(e, element.id)}
                key={`navigation__menu-item-${index}`}
                ariaLabel={`Link zur ${element.name} sektion`}
              />
            ))}

          <div className="navigation__menu-item-indicator" />
        </div>
      </header>

      {!overlayOpened && (
        <div
          className={`navigation__burger${
            activeMenu ? " navigation__burger--active" : ""
          }`}
          onClick={() => setActiveMenu(!activeMenu)}
        >
          <div className="navigation__burger-line" />
        </div>
      )}
    </Fragment>
  );
}

export default Navigation;
